// LogInWithCode logs in a user with a CO code & state.
export const AuthenticationService_LogInWithCodeLazy = () =>
  import("./service.grpc").then((m) => m.AuthenticationService_LogInWithCode);
AuthenticationService_LogInWithCodeLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/LogInWithCode" as const;

// GetSSOButtons gets the available SSO buttons for the given config.
export const AuthenticationService_GetSSOButtonsLazy = () =>
  import("./service.grpc").then((m) => m.AuthenticationService_GetSSOButtons);
AuthenticationService_GetSSOButtonsLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/GetSSOButtons" as const;

// LogInWithEmail logs a customer in with their email and password.
//
// A guest session passed along is linked onto the customer, so the basket and wishlist
// they filled as a guest survive the login.
export const AuthenticationService_LogInWithEmailLazy = () =>
  import("./service.grpc").then((m) => m.AuthenticationService_LogInWithEmail);
AuthenticationService_LogInWithEmailLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/LogInWithEmail" as const;

// RegisterWithEmail creates an account for an email and password.
//
// When an account for that email already exists, the customer is logged in with the
// credentials they just sent instead of the call failing, and is_already_registered is
// set on the response.
export const AuthenticationService_RegisterWithEmailLazy = () =>
  import("./service.grpc").then(
    (m) => m.AuthenticationService_RegisterWithEmail
  );
AuthenticationService_RegisterWithEmailLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/RegisterWithEmail" as const;

// Logout logs the customer out of checkout and drops their session.
export const AuthenticationService_LogoutLazy = () =>
  import("./service.grpc").then((m) => m.AuthenticationService_Logout);
AuthenticationService_LogoutLazy.method =
  "aysa_api.services.authentication.v1.AuthenticationService/Logout" as const;
